import { MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps } from 'antd';
import { useEffect, useState } from 'react';

interface RowMenuDropdownProps {
  menuProps: MenuProps;
  className?: string;
}

export const RowMenuDropdown = ({ menuProps, className }: RowMenuDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // No actions to show (e.g. All Tasks passes an empty menu) — render nothing.
  // The operation cell keeps its fixed width, so the column space stays the same.
  const hasItems = !!(menuProps.items && menuProps.items.length > 0);

  // Block scroll when dropdown is open
  useEffect(() => {
    if (isOpen) {
      // Find the table body to block its scroll
      const tableBody = document.querySelector('.ant-table-body') as HTMLElement;

      if (tableBody) {
        // Store the current scroll position and overflow
        const scrollTop = tableBody.scrollTop;
        const originalOverflow = tableBody.style.overflow;

        // Block scroll
        tableBody.style.overflow = 'hidden';

        return () => {
          // Restore scroll
          tableBody.style.overflow = originalOverflow;
          // Restore scroll position
          tableBody.scrollTop = scrollTop;
        };
      }
    }
  }, [isOpen]);

  const handleOverlayClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(false);
  };

  if (!hasItems) return null;

  return (
    <>
      {/* Overlay to prevent click-through when dropdown is open */}
      {isOpen && (
        <div
          className="fixed inset-0 z-[999]"
          style={{ background: 'transparent' }}
          onClick={handleOverlayClick}
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
        />
      )}

      <Dropdown
        menu={menuProps}
        className={className}
        trigger={['click']}
        open={isOpen}
        onOpenChange={setIsOpen}
        overlayStyle={{
          zIndex: 1000,
        }}
      >
        <Button className="" style={{ height: '20px', width: '20px', padding: 0 }}>
          <div className="flex justify-center items-center">
            <MoreOutlined />
          </div>
        </Button>
      </Dropdown>
    </>
  );
};
